<template>
  <div class="page" :class="{ sent: sent }">
    <div class="header">
      <HeaderBlock />
    </div>
    <div class="container" :class="{ flex: sent }">
      <template v-if="!sent">
        <div class="column left">
          <h5 class="text-44">Анкета участника</h5>
          <p class="text-16 mt-15px">
            Заполните анкету участника (проследите, чтобы все данные были
            заполнены верно). После отправки заявка пройдет модерацию и наш
            менеджер свяжется с вами
          </p>
          <NuxtImg src="/img/form-img.png" />
        </div>
        <div class="column right">
          <div class="form">
            <UiSelect
              v-model="formData.nominations"
              :class="{ 'input-error': errors.nominations }"
              :options="nominations"
              placeholder="Выберите номинацию"
              :max-selections="3"
            />
            <!--
 <UiTextarea
              v-model="formData.shortDescription"
              :class="{ 'input-error': errors.shortDescription }"
              placeholder="Описание компании (до 150 знаков)"
            />
-->
            <!--
 <div v-if="errors.shortDescription" class="error-message">
              {{ errors.shortDescription }}
            </div> 
-->

            <h6 class="text-12 mt-15px">Данные компании</h6>

            <UiInput
              v-model="formData.username"
              :class="{ 'input-error': errors.username }"
              placeholder="ФИО"
            />
            <div v-if="errors.username" class="error-message">
              {{ errors.username }}
            </div>

            <UiInput
              v-model="formData.regalia"
              :class="{ 'input-error': errors.regalia }"
              placeholder="Должность"
            />
            <div v-if="errors.regalia" class="error-message">
              {{ errors.regalia }}
            </div>

            <UiMaskInput
              v-model="formData.phone"
              :class="{ 'input-error': errors.phone }"
              placeholder="Телефон"
            />
            <div v-if="errors.phone" class="error-message">
              {{ errors.phone }}
            </div>

            <UiInput
              v-model="formData.email"
              :class="{ 'input-error': errors.email }"
              placeholder="Почта"
            />
            <div v-if="errors.email" class="error-message">
              {{ errors.email }}
            </div>

            <UiInput
              v-model="formData.companyName"
              :class="{ 'input-error': errors.companyName }"
              placeholder="Название компании"
            />
            <div v-if="errors.companyName" class="error-message">
              {{ errors.companyName }}
            </div>

            <UiTextarea
              v-model="formData.companyDescription"
              :class="{ 'input-error': errors.companyDescription }"
              placeholder="Описание деятельности (до 1000 знаков)*"
            />
            <div v-if="errors.companyDescription" class="error-message">
              {{ errors.companyDescription }}
            </div>

            <UiInput
              v-model="formData.companyWebsite"
              :class="{ 'input-error': errors.companyDescription }"
              placeholder="Ссылка на сайт компании"
            />
            <div v-if="errors.companyWebsite" class="error-message">
              {{ errors.companyWebsite }}
            </div>

            <!--
 <UiTextarea
              v-model="formData.companyComment"
              placeholder="Комментарий представителя компании (до 300 знаков)"
            />
            <div v-if="errors.companyComment" class="error-message">
              {{ errors.companyComment }}
            </div>
-->

            <div class="flex-column flex-align-start gap-40">
              <div class="flex-column gap-14 mt-15px">
                <p>Логотип компании в белом цвете (загрузите в формате svg)</p>
                <UiFileUploader
                  v-model="formData.logo"
                  @change="validateField('logo')"
                />
                <div v-if="errors.logo" class="mt-15px error-message">
                  {{ errors.logo }}
                </div>
              </div>

              <!--
 <div class="flex-column gap-14 mt-15px">
                <p>
                  Фото представителя компании (загрузите в формате JPEG, PNG до
                  5МБ)
                </p>
                <UiFileUploader
                  v-model="formData.photo"
                  @change="validateField('photo')"
                />
                <div v-if="errors.photo" class="error-message">
                  {{ errors.photo }}
                </div>
              </div>
-->
            </div>

            <div class="flex-column gap-14 mt-15px">
              <div class="flex gap-16">
                <UiCheckbox v-model="formData.agreeWithPolicy" />
                <label>
                  Ознакомлен с
                  <NuxtLink class="text-purple" :to="{ name: 'oferta' }">
                    положением о премии
                  </NuxtLink>
                </label>
              </div>
              <div class="mt-15px flex-column gap-14">
                <div v-if="errors.agreeWithPolicy" class="error-message">
                  {{ errors.agreeWithPolicy }}
                </div>
              </div>
            </div>
            <div v-if="errorFromApi" class="error-message">
              {{ errorFromApi }}
            </div>
            <UiButton class="" @click="handleSubmit"> Отправить </UiButton>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="success">
          <h5>Анкета отправлена!</h5>
          <p>
            Спасибо за участие. Ваша анкета пройдет модерацию и наш менеджер
            свяжется с вами
          </p>
        </div>
      </template>
    </div>
    <FooterBlock class="z-3" />
  </div>
</template>

<script setup>
const sent = ref(false)
const errorFromApi = ref("")
const nominations = await getNominations()

const formData = ref({
  nominations: [],
  // shortDescription: "",
  username: "",
  regalia: "",
  phone: "",
  email: "",
  companyName: "",
  companyDescription: "",
  companyWebsite: "",
  // companyComment: "",
  logo: null,
  // photo: null,
  agreeWithPolicy: false,
})

const errors = ref({
  description: "",
  // shortDescription: "",
  username: "",
  regalia: "",
  phone: "",
  email: "",
  companyName: "",
  companyDescription: "",
  companyWebsite: "",
  // companyComment: "",
  // logo: "",
  // photo: "",
  agreeWithPolicy: "",
})

// const getDescription = (id) => {
//   const { attributes } = formData.value.nominations.find(
//     (item) => item.id === id,
//   )
//   return attributes.name
// }

const validateField = (field) => {
  const value = formData.value[field]
  let errorMessage = ""
  if (field === "nominations" && !value.length) {
    errorMessage = "Выберите номинацию."
  } else if (field === "username" && !value) {
    errorMessage = "Введите ФИО."
  }
  // else if (field === "shortDescription" && (!value || value.length > 150)) {
  //   errorMessage = "Введите описание компании (до 150 знаков)."
  // }
  // else if (field === "regalia" && !value) {
  //   errorMessage = "Введите регалии."
  // }
  else if (field === "phone" && !validatePhone(value)) {
    errorMessage = "Введите корректный номер телефона."
  } else if (field === "email" && !validateEmail(value)) {
    errorMessage = "Введите корректный адрес электронной почты."
  }
  //  else if (field === "companyName" && !value) {
  //   errorMessage = "Введите название компании."
  // }
  else if (field === "companyDescription" && (!value || value.length > 1000)) {
    errorMessage = "Введите описание деятельности компании (до 1000 знаков)."
  }
  // else if (field === "companyWebsite" && !value) {
  //   errorMessage = "Введите ссылку на сайт компании."
  // }
  // else if (field === "logo" && !value) {
  //   errorMessage = "Загрузите логотип компании."
  // }
  else if (field === "companyWebsite" && !value) {
    errorMessage = "Введите корректный URL-адрес сайта компании."
  } else if (field === "photo") {
    // if (!value) {
    //   errorMessage = "Загрузите фото представителя компании."
    // } else
    if (value?.type && !["image/jpeg", "image/png"].includes(value.type)) {
      errorMessage = "Фото должно быть в формате JPEG или PNG."
    } else if (value?.size && value.size > 5 * 1024 * 1024) {
      errorMessage = "Файл должен быть меньше 5 МБ."
    }
  } else if (field === "agreeWithPolicy" && !value) {
    errorMessage = "Необходимо согласие с положением о премии."
  } else if (field === "companyComment" && value.length > 300) {
    errorMessage = "Введите комментарий представителя компании (до 300 знаков)."
  }
  errors.value[field] = errorMessage
}

Object.keys(formData.value).forEach((field) => {
  watch(
    () => formData.value[field],
    () => {
      validateField(field)
    },
    { deep: true },
  )
})

const hasErrors = () => {
  const checkErrors = (obj) => {
    return Object.values(obj).some((value) => {
      if (typeof value === "object" && value !== null) {
        return checkErrors(value)
      }
      return value !== ""
    })
  }

  return checkErrors(errors.value)
}

const handleSubmit = async () => {
  Object.keys(formData.value).forEach((field) => validateField(field))
  if (!hasErrors()) {
    const data = {
      username: formData.value.username,
      email: formData.value.email,
      position: formData.value.regalia,
      company: formData.value.companyName,
      phone: formData.value.phone,
      website: formData.value.companyWebsite,
      comment: formData.value.companyComment,
      description: formData.value.companyDescription,
      nominations: formData.value.nominations,
      // shortDescription: formData.value.shortDescription,
    }
    const files = []
    if (formData.value?.logo) {
      files.push({
        name: "logo",
        file: formData.value.logo,
      })
    }
    // if (formData.value?.photo) {
    //   files.push({
    //     name: "photo",
    //     file: formData.value.photo,
    //   })
    // }
    try {
      const response = await sendParticipant(data, files)
      if (response === true) {
        sent.value = true
      }
    } catch (error) {
      errorFromApi.value = formErrorHandler(error.error?.message)
    }
  } else {
    console.log("Есть ошибки в форме:", errors.value)
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100dvh;
  background: #f5f6fb;
  position: relative;
  display: flex;
  flex-direction: column;
  &::before {
    content: url("@/public/img/bg_form_page.png");
    position: absolute;
    max-width: 440px;
    top: 15%;
    width: 100%;
    left: 0;
    z-index: 1;
    opacity: 0.3;
    user-select: none;
    pointer-events: none;

    @media (max-width: 1325px) {
      content: "";
    }
  }

  &.sent {
    &::before {
      content: "";
    }
  }
}

.header {
  width: 100%;
  z-index: 99;
}

.container {
  flex-grow: 1;
  min-height: 100dvh;
  display: flex;
  justify-content: space-between;
  max-width: 1440px;
  padding: 120px 70px 124px;
  width: 100%;
  margin: 0 auto;

  .column {
    &.right {
      margin-left: auto;
      max-width: 640px;
      width: 100%;
      @include md {
        margin: 0 auto;
      }
    }

    &.left {
      position: fixed;
      margin-left: auto;
      width: 35vw;
      max-width: 640px;
      z-index: 2;
      p {
        max-width: 416px;
      }
      img {
        width: 100%;
        margin-top: 76px;
      }
    }
  }

  @media (max-width: 1325px) {
    flex-wrap: wrap;
    padding: 100px 70px;
    gap: 50px;
    align-items: center;
    .column {
      &.right {
        margin: 0 auto;
        max-width: 640px;
        @include md {
          margin: 0 auto;
        }
      }

      &.left {
        position: static;
        width: 100%;
        margin: 0 auto;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          display: none;
        }
      }
    }
  }

  @include sm {
    padding: 100px 16px;
    .column {
      width: 100%;
    }
  }
}

.form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 12px;
  color: $color-dark-gray;
}

.input-error {
  border: 1px solid red;
}

.error-message {
  margin-top: -15px;
  color: red;
  font-size: 12px;
}

.success {
  margin: auto;
  max-width: 344px;
  width: 100%;
  text-align: center;
  h5 {
    font-size: 32px;
  }
  p {
    font-size: 16px;
    margin-top: 30px;
  }
}

.z-3 {
  z-index: 3;
}
</style>
